import React from 'react';
import moment from 'moment';
import { Box } from '@material-ui/core';
import { useStyles } from './styles';
import { useAppConfiguration } from '../hook';
import ChipList from '../chip-list';
import { getEventLabel } from '../../../utils/event-type';

export const DataTable = ({
  t,
  columns,
  bookingHistoryList,
}: {
  t: any;
  columns: any;
  bookingHistoryList: any;
}) => {
  const classes = useStyles();
  const { withUnlimitedCredits } = useAppConfiguration();

  return (
    <Box className={classes.table}>
      <Box className={classes.tableHeadRow}>
        {columns.map((column: any) => {
          return (
            <Box className={classes.tableHeadCell}>
              <span className={classes.tableHeadValue}>
                {column.headerName}
              </span>
            </Box>
          );
        })}
      </Box>

      {bookingHistoryList.map((booking: any) => {
        return (
          <Box className={classes.tableRow} key={booking.id}>
            <Box className={classes.tableCell}>
              <Box className={classes.columnValue} style={{ minWidth: '60%' }}>
                <span className={classes.boldValue}>
                  {booking.offeringName}
                </span>
              </Box>
            </Box>
            <Box className={classes.tableCell}>
              <Box className={classes.columnValue}>
                {moment(booking.bookedAt).local().format('DD.MM.yyyy')}
              </Box>
            </Box>
            {!withUnlimitedCredits && (
              <Box className={classes.tableCell}>
                <Box className={classes.columnValue}>
                  {booking.offeringPrice}
                </Box>
              </Box>
            )}
            <Box className={classes.tableCell}>
              <Box className={classes.columnValue}>
                <ChipList
                  list={[getEventLabel(booking.offeringType)]}
                  style={{ margin: 0 }}
                />
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};
